module.exports = {
	"title": "findify-layouts--recommendation--grid__title"
};